export default __webpack_public_path__ + "static/media/triangle_two.6c235d47.png";